'use client';

import type { SlotLinkProps } from '../Base/Slot.Link';
import { SlotLink } from '../Base/Slot.Link';
import { useJoeLink } from '../../shared/useJoeLink';

export const JoeSlot = (props: Pick<SlotLinkProps, 'priority'>) => {
  const { href, label, ariaLabel } = useJoeLink();

  return (
    <SlotLink {...props} href={href} label={label} ariaLabel={ariaLabel}>
      <div className="icon-emp-joe-logo size-4" />
    </SlotLink>
  );
};
